import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, LoadingSpinner } from '@allied-solutions/affinity'
import {
  Synced,
  Shield02,
  Bank,
} from '@allied-solutions/affinity-react-icons/standard'
import { DashboardTileNavListItem } from './DashboardTileNavListItem'
import { DashboardTileLoanInformation } from './DashboardTileLoanInformation'
import { DashboardTileCoverageRequirements } from './DashboardTileCoverageRequirements'
import { DashboardTileVerificationStatus } from './DashboardTileVerificationStatus'

export const DashboardTileContent = ({
  borrowerData,
  coverageRequirementsData,
  isLoadingCoverageRequirements,
  unmetRequirementsCount,
  openUploadModal,
  onActiveCoverageReferenceIdChange,
  onOpenHelp,
}) => {
  const [activeTab, setActiveTab] = useState('verification-status')
  const [
    coverageRequirementsAccountSlug,
    setCoverageRequirementsAccountSlug,
  ] = useState('0')

  const handleActiveCoverageAccountChange = (accountIndex, referenceId) => {
    setCoverageRequirementsAccountSlug(String(accountIndex))
    if (referenceId != null && referenceId !== '') {
      onActiveCoverageReferenceIdChange?.(String(referenceId))
    }
  }

  const navigateToCoverageRequirementsForAccount = accountIndex => {
    const account = coverageRequirementsData?.[accountIndex]
    handleActiveCoverageAccountChange(accountIndex, account?.ReferenceID)
    setActiveTab('coverage-requirements')
  }

  return (
    <Box display="flex" flexDirection="row">
      <Box
        display="flex"
        flexDirection="column"
        borderRight="1px solid"
        borderColor="border.defaultLight"
        pr="4xl"
        minWidth="280px"
      >
        <DashboardTileNavListItem
          title="Verification Status"
          id="verification-status"
          icon={Synced}
          isActive={activeTab === 'verification-status'}
          setActiveTab={setActiveTab}
        />
        <DashboardTileNavListItem
          title="Coverage Requirements"
          id="coverage-requirements"
          icon={Shield02}
          isActive={activeTab === 'coverage-requirements'}
          setActiveTab={setActiveTab}
          coverageRequirementsData={coverageRequirementsData}
        />
        <DashboardTileNavListItem
          title="Loan Information"
          id="loan-information"
          icon={Bank}
          isActive={activeTab === 'loan-information'}
          setActiveTab={setActiveTab}
        />
      </Box>
      <Box pl="4xl" width="100%">
        {activeTab === 'verification-status' && (
          <>
            {isLoadingCoverageRequirements && (
              <Box display="flex" alignItems="center" gap="md" py="lg">
                <LoadingSpinner size="sm" />
              </Box>
            )}
            {!isLoadingCoverageRequirements && coverageRequirementsData && (
              <DashboardTileVerificationStatus
                coverageRequirementsData={coverageRequirementsData}
                onNavigateToCoverageRequirements={
                  navigateToCoverageRequirementsForAccount
                }
                onActiveCoverageAccountChange={
                  handleActiveCoverageAccountChange
                }
              />
            )}
          </>
        )}
        {activeTab === 'coverage-requirements' && (
          <>
            {isLoadingCoverageRequirements && (
              <Box display="flex" alignItems="center" gap="md" py="lg">
                <LoadingSpinner size="sm" />
              </Box>
            )}
            {!isLoadingCoverageRequirements && coverageRequirementsData && (
              <DashboardTileCoverageRequirements
                coverageRequirementsData={coverageRequirementsData}
                initialAccountSlug={coverageRequirementsAccountSlug}
                unmetRequirementsCount={unmetRequirementsCount}
                openUploadModal={openUploadModal}
                onActiveCoverageAccountChange={
                  handleActiveCoverageAccountChange
                }
                onOpenHelp={onOpenHelp}
              />
            )}
          </>
        )}
        {activeTab === 'loan-information' && (
          <DashboardTileLoanInformation borrowerData={borrowerData} />
        )}
      </Box>
    </Box>
  )
}

DashboardTileContent.propTypes = {
  borrowerData: PropTypes.object,
  coverageRequirementsData: PropTypes.arrayOf(PropTypes.object),
  isLoadingCoverageRequirements: PropTypes.bool,
  unmetRequirementsCount: PropTypes.number,
  openUploadModal: PropTypes.func,
  onActiveCoverageReferenceIdChange: PropTypes.func,
  onOpenHelp: PropTypes.func,
}
